import React, { useState } from "react";
import { Autocomplete, Button, Stack, TextField } from "@mui/material";

import { useReportsMetaSelector, useDealActions } from "store";
import { indexNames } from "constants/reports";
import { DEAL_INDEX } from "constants/reports";
interface Props {
  cubicKey: string;
  filter: string;
  title: string;
  handleClose: () => void;
}

export const KPIMenuContent: React.FC<Props> = ({ cubicKey, filter, title, handleClose }) => {
  const [filterValue, setFilterValue] = useState<string>(filter);
  const [titleValue, setTitleValue] = useState<string>(title);
  const [PMEIndex, setPMEIndex] = useState<{ index: string; name: string } | undefined>({
    index: DEAL_INDEX,
    name: "Use deal specific index"
  });

  const { KPIFields } = useReportsMetaSelector();
  const { setDealsQueryCubic } = useDealActions();

  const handleSubmit = () => {
    setDealsQueryCubic({
      cubicKey,
      title: titleValue,
      filter: filterValue,
      ...(filterValue === "PME" && PMEIndex?.index !== DEAL_INDEX && { indexName: PMEIndex })
    });
    handleClose();
  };

  const disabled = !filterValue || !titleValue;

  return (
    <>
      <Autocomplete
        options={KPIFields}
        onChange={(_, option) => {
          setFilterValue(option);
          setTitleValue(option);
        }}
        value={filterValue}
        disableClearable
        renderInput={(params) => <TextField {...params} label="Value" size="small" />}
        limitTags={2}
      />
      {filterValue === "PME" && (
        <Autocomplete
          options={["Use deal specific index", ...Object.values(indexNames)]}
          value={PMEIndex?.name}
          onChange={(_, selectedValue) => {
            if (!selectedValue) return;
            if (selectedValue === "Use deal specific index") {
              setPMEIndex({ index: DEAL_INDEX, name: selectedValue });
              return;
            }
            const indexKey = Object.entries(indexNames).find(([, val]) => val === selectedValue)?.[0];
            if (indexKey) {
              setPMEIndex({ index: indexKey, name: selectedValue });
            }
          }}
          renderInput={(params) => <TextField {...params} label="Index" size="small" />}
          disableClearable
          limitTags={2}
        />
      )}
      <TextField
        value={titleValue}
        label="Rename"
        variant="outlined"
        onChange={(event) => setTitleValue(event.target.value)}
      />
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" disabled={disabled} onClick={handleSubmit}>
          Apply
        </Button>
      </Stack>
    </>
  );
};